import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';

/**
 * Route User Cell Renderer
 * Muestra información de ruta, usuario y responsable usando UserRouteDisplayComponent
 */
@Component({
  selector: 'app-route-user-cell-renderer',
  standalone: true,
  imports: [CommonModule, UserRouteDisplayComponent],
  template: `
    <app-user-route-display
      class="leading-tight"
      [routeData]="routeData"
      [userData]="userData"
      [responsibleData]="responsibleData"
      [displayMode]="'detailed'"
      [showRouteCode]="true"
      [showUser]="true"
      [showResponsible]="true">
    </app-user-route-display>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class RouteUserCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get routeData() {
    const data = this.params?.data;
    if (!data) return { routeName: '-', externalKeys: { code: '-' } };

    const subRoute = data.subRoute;
    return {
      routeName: subRoute?.name ?? '-',
      externalKeys: {
        code: subRoute?.id?.toString() ?? '-'
      }
    };
  }

  get userData() {
    const data = this.params?.data;
    if (!data) return { name: '-', username: '-' };

    const subRoute = data.subRoute;
    return {
      name: subRoute?.mainCollaboratorUsername ??
            data.user?.user_login?.username ?? '-',
      username: subRoute?.mainCollaboratorUsername ??
                data.user?.user_login?.username ?? '-'
    };
  }

  get responsibleData() {
    const data = this.params?.data;
    if (!data) return { name: '-', personNumber: '-', externalKeys: { code: '-' } };

    const subRoute = data.subRoute;
    return {
      name: subRoute?.responsibleName ?? '-',
      personNumber: '-',
      externalKeys: {
        code: subRoute?.responsibleCode ?? '-'
      }
    };
  }
}
